import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Checkbox,
  MenuItem,
  Menu,
  Typography,
  Pagination,
  PaginationItem,
  CircularProgress,
} from "@mui/material";
import {
  PrimaryTypography,
  StyledSecondaryServiceTypography,
  StyledOutlinedInput,
  SecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  StyledSecondaryTypography,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import moment from "moment";
import { StatusChip } from "../../CommonComponents/StatusChip";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";

const SalesOverview = () => {
  const navigate = useNavigate();

  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const [allStatus, setAllStatus] = useState([]);
  const sortOpen = Boolean(sortAnchorEl);
  const [sortAsc, setSortAsc] = useState("");
  const [status, setStatus] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterOpen = Boolean(filterAnchorEl);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState("10");
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const showOpen = Boolean(showAnchorEl);
  const [tableLoading, setTableDataLoading] = useState(false);
  const TableHeaders = [
    "Company",
    "Project",
    "Type",
    "Status",
    "Start Date",
    "Action",
  ];

  const filterData = ["Onboarding", "Active", "Renewal", "Inactive"];
  const getTableData = () => {
    setTableDataLoading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}property?page=${currentPage}&sort=${sortAsc}&search=${search}&record_count=${rowsPerPage}&status=${status}`
      )
      .then((res) => {
        console.log(
          res?.data?.data?.properties[res?.data?.data?.properties.length - 1]
        );
        setTableData(res?.data?.data?.properties || []);
        setPaginationData(res?.data?.data?.pagination_details);
        setTableDataLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          setTableData([]);
          setTableDataLoading(false);
        }
        setTableDataLoading(false);
      });
  };

  const handleCheckboxChange = (item) => (event) => {
    setStatus((prev) => {
      if (event.target.checked) {
        return prev.includes(item?.id) ? prev : [...prev, item?.id];
      }

      return prev.filter((id) => id !== item?.id);
    });
  };
  console.log("status", status);
  const getStatus = () => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=property_status`
      )
      .then((res) => {
        console.log(res?.data?.data?.drop_down);
        setAllStatus(res?.data?.data?.drop_down || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getTableData();
  }, [currentPage, search, sortAsc, , rowsPerPage, status]);
  useEffect(() => {
    getStatus();
  }, []);
  useEffect(() => {
    if (tableData.length === 0) {
      setCurrentPage(1);
    }
  }, [tableData]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <PrimaryTypography>Sales Overview</PrimaryTypography>
          <StyledSecondaryServiceTypography>
            Manage all of your post sales funnel information
          </StyledSecondaryServiceTypography>
        </Box>
        <Button
          style={{
            borderRadius: "8px",
            padding: "10px 16px 10px 16px",
            backgroundColor: "#0E5E84",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "14px",
          }}
          onClick={() => navigate("/create-account")}
        >
          Add Account{" "}
        </Button>
      </Box>
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          p: 3,
          mt: 4,
          borderRadius: " 8px 8px 0px 0px",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            height: "40px",
            minWidth: "580px",
          }}
        >
          <StyledOutlinedInput
            sx={{ flexGrow: 1 }}
            placeholder="Search"
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #E5E7EB",
              borderRadius: "6px",
              px: 2,
              ml: 2,
              "&:hover": { cursor: "pointer" },
            }}
            onClick={(e) => {
              setSortAnchorEl(e.currentTarget);
            }}
          >
            <SortIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>Sort</SecondaryTypography>
          </Box>
          <Box
            onClick={(e) => setFilterAnchorEl(e.currentTarget)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #E5E7EB",
              borderRadius: "6px",
              px: 2,
              ml: 2,
              "&:hover": { cursor: "pointer" },
            }}
          >
            <FilterIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>Filters</SecondaryTypography>
          </Box>
        </Box>
      </Box>
      {tableLoading ? (
        <Box
          sx={{ width: "100%", height: "200px" }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress />
        </Box>
      ) : tableData.length > 0 ? (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <StyledTableRow sx={{ height: "44px" }}>
                  <StyledTableCell>
                    {" "}
                    <Checkbox
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      sx={{ height: "40px", minWidth: "43px" }}
                      size="small"
                      icon={<CheckboxIcon />}
                    />
                  </StyledTableCell>
                  {TableHeaders.map((value, index) => (
                    <StyledTableCell key={index}>{value}</StyledTableCell>
                  ))}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {tableData.map((value, index) => (
                  <StyledTableRow
                    onClick={() => navigate(`/review-account/${value?.id}`)}
                    key={index}
                    sx={{ height: "70px" }}
                  >
                    <StyledTableCell>
                      {" "}
                      <Checkbox
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        sx={{ height: "40px", minWidth: "43px" }}
                        size="small"
                        icon={<CheckboxIcon />}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{value?.company?.name}</StyledTableCell>
                    <StyledTableCell>{value?.title}</StyledTableCell>
                    <StyledTableCell>{value?.type?.name}</StyledTableCell>
                    <StyledTableCell>
                      {StatusChip(value?.status_details?.key)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {value?.billing_detail?.commence_date}
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => navigate(`/review-account/${value?.id}`)}
                    >
                      View Details
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              borderTopStyle: "none !important",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
              >
                Show :
              </Typography>
              <Box
                onClick={(e) => setshowAnchorEl(e.currentTarget)}
                sx={{
                  width: "95px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #E5E7EB",
                  borderRadius: "6px",
                  ml: 2,
                  "&:hover": { cursor: "pointer" },
                }}
              >
                <Typography
                  sx={{ fontSize: "15px" }}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {rowsPerPage} rows{" "}
                </Typography>
              </Box>
            </Box>
            <Pagination
              size="medium"
              page={currentPage}
              count={paginationData?.last_page}
              onChange={(e, value) => setCurrentPage(value)}
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: PreviousIcon, next: NextIcon }}
                  {...item}
                />
              )}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "50vh",
            justifyContent: "center",
            borderRadius: "0px 0px 8px 8px",
            border: "1px solid #F9FAFB",
            backgroundColor: "#F9FAFB",
          }}
        >
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Account Here
            </Typography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              There are no account to display at the moment.
            </StyledSecondaryTypography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              You may add account by clicking the top right Add button.
            </StyledSecondaryTypography>
          </>
        </Box>
      )}
      <Menu
        sx={{ m: 0.5 }}
        open={showOpen}
        anchorEl={showAnchorEl}
        onClose={() => setshowAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setRowsPerPage(10);
            setshowAnchorEl(null);
          }}
        >
          <Typography>10 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(20);
            setshowAnchorEl(null);
          }}
        >
          <Typography>20 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(30);
            setshowAnchorEl(null);
          }}
        >
          <Typography>30 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(40);
            setshowAnchorEl(null);
          }}
        >
          <Typography>40 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(50);
            setshowAnchorEl(null);
          }}
        >
          <Typography>50 rows</Typography>
        </MenuItem>
      </Menu>
      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setSortAsc("recent");
            setSortAnchorEl(null);
          }}
        >
          <Typography>Most Recent</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortAsc("old");
            setSortAnchorEl(null);
          }}
        >
          <Typography>Oldest</Typography>
        </MenuItem>
      </Menu>
      <Menu
        sx={{ width: "312px", height: "459px" }}
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
      >
        {allStatus?.map((itm, index) => (
          <MenuItem key={index}>
            <Checkbox
              sx={{ width: "42px", height: "42px" }}
              icon={<CheckboxIcon />}
              checked={status.includes(itm?.id)}
              onChange={handleCheckboxChange(itm)}
            />
            <Typography sx={{ mr: 3 }}>{itm?.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SalesOverview;
